export default "__VITE_ASSET__DDq95$hB__"